import { ENTRIES_ROUTES } from '../../constants/routePaths'
import { formatRoute } from 'react-router-named-routes'
import entriesTypes from '../../constants/entriesTypes'
import { axios } from '../../services'

// sort by column
const set_sorting = (sort='', order='') => {
  const sorting = {
    sort: sort,
    order: order
  }
  return {
    type: entriesTypes.set_sorting,
    payload: sorting
  }
}
// add custom columns
const add_columns_request = () => {
  return {
    type: entriesTypes.add_columns.request
  }
}

const add_columns_success = (response) => {
  return {
    // type: entriesTypes.index.success,
    type: entriesTypes.add_columns.success,
    payload: response.data
  }
}

const add_columns_failure = (messages) => {
  return {
    type: entriesTypes.add_columns.failure,
    payload: messages
  }
}

const add_columns = ( feed_id, columns_string, before='' ) => {
  return function (dispatch) {
    // REQUEST
    dispatch(add_columns_request())

    axios.patch(
      formatRoute(ENTRIES_ROUTES.add_columns, {id: feed_id}),
      {
    		// page: 1,
    		// per_page: 50,
        key: columns_string,
        before: before
      }
    ).then( response => {
      // success
      dispatch( add_columns_success(response) )

    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Couldn't add columns."]
      }
      dispatch( add_columns_failure(errors) )
    })
  }
}

const remove_column = ( feed_id, column ) => {
  return function (dispatch) {
    // REQUEST
    dispatch(add_columns_request())

    axios.delete(
      formatRoute(ENTRIES_ROUTES.remove_column, {id: feed_id}),
      {
        params: {
          key: column
        }
      }
    ).then( response => {
      // success
      dispatch( add_columns_success(response) )

    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Couldn't remove column."]
      }
      dispatch( add_columns_failure(errors) )
    })
  }
}

// add 2 Columns
const add_title_columns_request = () => {
  return {
    type: entriesTypes.add_columns.request
  }
}

const add_title_columns_success = (response) => {
  return {
    type: entriesTypes.add_columns.success,
    payload: response.data
  }
}

const add_title_columns_failure = (messages) => {
  return {
    type: entriesTypes.add_columns.failure,
    payload: messages
  }
}

const add_title_columns = ( feed_id ) => {
  return function (dispatch) {
    // REQUEST
    dispatch(add_title_columns_request())

    axios.post(
      formatRoute(ENTRIES_ROUTES.add_title_columns, {id: feed_id}),
      {
    		page: 1,
    		per_page: 50
      }
    ).then( response => {
      // success
      dispatch( add_title_columns_success(response) )

    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Couldn't add columns."]
      }
      dispatch( add_title_columns_failure(errors) )
    })
  }
}

export {
  set_sorting,
  add_columns,
  remove_column,
  add_title_columns
}



// WEBPACK FOOTER //
// ./src/js/actions/entries/columns_actions.js